module.exports = __webpack_public_path__ + "img/bg-0104-bak.9100a104.png";